<script lang="ts" setup>
import type { CSSProperties } from 'vue';

import ImageMedia from '../media/ImageMedia.vue';
import type { Logo, LogoSize } from './AppLogo';

const props = withDefaults(defineProps<{ logo: Logo; size?: LogoSize; pad?: boolean }>(), {
  size: 'medium',
});

const logoBackgroundColor = computed<CSSProperties>((): CSSProperties => {
  if (!props.logo?.logoBackgroundColor) {
    return {};
  }
  return { background: props.logo.logoBackgroundColor };
});
</script>

<template>
  <div class="app-icon" :class="`app-icon--${size}`">
    <ImageMedia
      v-if="logo?.logoUrl"
      :filename="logo.logoUrl"
      :style="logoBackgroundColor"
      :class="{ pad: pad }"
    />

    <div v-if="$slots.title" class="app-title">
      <slot name="title" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use 'core/layout/grid-vars';
@use 'core/util';

.app-icon {
  display: flex;
  align-items: center;

  .app-title {
    margin-left: grid-vars.space(2);
  }

  &--x-small {
    :deep(.image-media) {
      width: grid-vars.space(3);
      height: grid-vars.space(3);
    }
  }

  &--small {
    :deep(.image-media) {
      width: grid-vars.space(6);
      height: grid-vars.space(6);
    }
  }

  &--medium {
    :deep(.image-media) {
      width: grid-vars.space(8);
      height: grid-vars.space(8);
    }
  }

  &--large {
    :deep(.image-media) {
      width: grid-vars.space(10);
      height: grid-vars.space(10);
    }
  }

  :deep(.image-media) {
    @include util.borders-sphere;

    display: flex;
    align-items: center;
    justify-content: center;

    // padding: space(1);
    overflow: hidden;

    // background-color: colors.color(offwhite);
    // box-shadow: inset 0 0 15px rgb(0 0 0 / 10%);
  }

  .pad {
    padding: grid-vars.space(1);
  }
}
</style>
